// Refer: https://gist.github.com/linhlc888/520b05a87be0ac98ccbba0cb83299086
import Encoding from 'encoding-japanese';

export const convertToShiftJIS = function (target: any) {
    const CHUNK_SIZE = 5000; // Number of lines per chunk
    const newline = new Uint8Array([10]); // LF (\n)
    const blobParts: any = [];
    const lines = target.split('\n');
    const receivedData = lines.pop() || '';  

    // Process each chunk
    for (let i = 0; i < lines.length; i += CHUNK_SIZE) {
        const chunk = lines.slice(i, i + CHUNK_SIZE);
        const chunkRows = chunk.map((line: any) => {
            // Convert to Shift-JIS
            const uniArray = Encoding.stringToCode(line);
            const sjisArray = Encoding.convert(uniArray, {
                to: 'SJIS',
                from: 'UNICODE',
            });

            return new Uint8Array(sjisArray);
        });

        // Add newline after every uint8Array in chunk
        chunkRows.forEach((uint8Array: any, index: any) => {
            blobParts.push(uint8Array);
            if (index < chunk.length - 1 || i + chunk.length < lines.length) {
                // Add newline after every line except the last total
                blobParts.push(newline);
            }
        });
    }

    return blobParts;
};